import React from 'react';
import { Check, Clock, Users, Shield, Star, Headphones } from 'lucide-react';


const ReasonCard = ({ icon: Icon, title, delay }) => (
  <div
    className={`
      relative overflow-hidden
      bg-transparent rounded-xl p-4 md:p-8      
      transform transition-all duration-500 ease-out
      hover:scale-105 
      group
      flex flex-col items-center  
    `}
    style={{ animationDelay: delay }}
  >
    {/* Background Gradient Effect */}
    <div className="absolute inset-0 bg-gradient-to-br  opacity-0 group-hover:opacity-100 transition-opacity duration-500"/>
    
    {/* Icon Container - עכשיו ממורכז */}
    <div className="relative mb-4 flex justify-center">
      <div className="w-12 h-12 md:w-16 md:h-16 rounded-xl bg-gradient-to-r from-[#97a9b6] to-[#9bc4e4] p-3 md:p-4 transform transition-transform group-hover:rotate-6">
        <Icon className="w-full h-full text-white" />
      </div>
    </div>

    {/* Content - עכשיו ממורכז */}
    <h3 className="text-base md:text-xl font-bold mb-2 text-gray-800 group-hover:text-[#9bc4e4]transition-colors duration-300 text-center">
      {title}
    </h3>

    {/* Bottom Line Decoration */}
    <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r  transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500"/>
  </div>
);

const ReasonsList = () => {
  const firstRow = [
    { icon: Users, title: 'ליווי אישי צמוד' },
    { icon: Star, title: 'מקצועיות ומומחיות' },
    { icon: Shield, title: 'דיסקרטיות מלאה' }
  ];

  const secondRow = [
    { icon: Clock, title: 'זמינות ומענה מהיר' },
    { icon: Check, title: 'שקיפות מלאה' },
    { icon: Headphones, title: 'יחס אישי' }
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 py-12 md:py-20   bg-[var(--bg-primary)]">
      <div className="text-center max-w-2xl mx-auto mb-10 md:mb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 bg-gradient-to-r  from-[#97a9b6] to-[#35434e] bg-clip-text text-transparent">
          למה לבחור בנו?
        </h2>
        <div className="w-24 h-1 bg-gradient-to-r  from-[#97a9b6] to-[#35434e]  mx-auto rounded-full"/>
      </div>

      <div className="space-y-4 md:space-y-8  ">
        {/* First Row */}
        <div className="grid grid-cols-3 gap-2 md:gap-8 ">
          {firstRow.map((reason, index) => (
            <ReasonCard 
              key={index}
              icon={reason.icon}
              title={reason.title}
              delay={`${index * 100}ms`}
            />
          ))}
        </div>

        {/* Second Row */}
        <div className="grid grid-cols-3 gap-2 md:gap-8">
          {secondRow.map((reason, index) => (
            <ReasonCard 
              key={index}
              icon={reason.icon}
              title={reason.title}
              delay={`${(index + 3) * 100}ms`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReasonsList;